import {
  CANCEL_SAVINGS_PLAN_START,
  CANCEL_SAVINGS_PLAN_SUCCESS,
  CANCEL_SAVINGS_PLAN_ERROR,
  CLEAR_CANCEL_SAVINGS_PLAN,
} from 'constants/action-types/savings';
import apiAction from 'helpers/apiAction';

export default data => dispatch =>
  dispatch(
    apiAction({
      method: 'post',
      url: '/CancelSavingsPlan',
      data,
      onStart: () => dispatch =>
        dispatch({
          type: CANCEL_SAVINGS_PLAN_START,
        }),
      onSuccess: res => dispatch => {
        const payload = Array.isArray(res) ? res[0] : res || {};
        return dispatch({
          type: CANCEL_SAVINGS_PLAN_SUCCESS,
          payload,
        });
      },
      onFailure: error => dispatch => {
        const err = Array.isArray(error) ? error[0] : error || {};
        return dispatch({
          type: CANCEL_SAVINGS_PLAN_ERROR,
          payload: {
            ...err,
          },
        });
      },
    }),
  );

export const clearSavingsCancelPlan = () => dispatch => {
  return dispatch({
    type: CLEAR_CANCEL_SAVINGS_PLAN,
  });
};
